// ToastNotifications.js
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastNotifications = () => {
  return (
    <>
      <ToastContainer />
    </>
  );
};

export default ToastNotifications;